import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import Axios from "axios";

import { useStyles } from "../../../../Components/CSS/TableStyle.css";
import StudentBody from "../StudentBody/StudentBody";
import AdminHeader from "../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import CustomTableHead from "../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import CustomTableFooter from "../../../../Components/Table/CutomTableFooter/CustomTableFooter";
import CustomEmptyMessage from "../../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import CustomSiteLoader from "../../../../Components/CustomSiteLoader/CustomSiteLoader";
import StudentFilter from "../StudentFilter/StudentFilter";
import PageTitle from "../../../../Components/PageTitle/PageTitle";
import { url } from "../../../../Config/Config";
import { connect } from "react-redux";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import CustomBreadCrumbs from "../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class ViewStudent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 10,
      page: 0,
      data: {
        subjectName: "",
        level: "",
        section: "",
        mobileNumber: "",
        status: "",
        year: "",
      },
      searchBy: {
        studentName: "",
        level: "",
        section: "",
        year: "",
      },
      column: [
        { name: "S.N." },
        { name: "Student Name" },
        { name: "Level" },
        { name: "Section" },
        { name: "Mobile" },
        { name: "Year Batch" },
        { name: "Actions" },
      ],
      students: [],
      isEmpty: false,
    };
  }

  componentDidMount() {
    this.getStudentsData();
  }

  getStudentsData = async () => {
    try {
      const response = await Axios.get(`${url}/api/students`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.students.length !== 0) {
        this.setState({
          students: response.data.students,
          isEmpty: false,
        });
      } else {
        this.setState({
          students: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getStudentsData();
      }
    }
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleSearch = (e) => {
    this.setState({
      searchBy: {
        ...this.state.searchBy,
        [e.target.name]: e.target.value,
      },
    });
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  render() {
    const { classes } = this.props;
    const { rowsPerPage, page } = this.state;

    const filtered = this.state.students.filter((student) => {
      return (
        student.firstName
          .toLowerCase()
          .indexOf(this.state.searchBy.studentName.toLowerCase()) !== -1 &&
        student.studentClass
          .toLowerCase()
          .indexOf(this.state.searchBy.level.toLowerCase()) !== -1 &&
        student.section
          .toLowerCase()
          .indexOf(this.state.searchBy.section.toLowerCase()) !== -1 &&
        student.currentSession
          .toLowerCase()
          .indexOf(this.state.searchBy.year.toLowerCase()) !== -1
      );
    });
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle
            title="Student Info"
            refreshUrl={this.props.match.url}
            addUrl={"/administration/students/add"}
            urlTitle="Add Student"
          />

          {this.state.students.length !== 0 && (
            <StudentFilter
              data={this.state.searchBy}
              handleSearch={this.handleSearch}
            />
          )}

          {this.state.students.length !== 0 ? (
            <TableContainer>
              <Table>
                <CustomTableHead column={this.state.column} />
                <TableBody>
                  {(rowsPerPage > 0
                    ? filtered.slice(
                        rowsPerPage * page,
                        rowsPerPage * page + rowsPerPage
                      )
                    : filtered
                  ).map((student, index) => (
                    <StudentBody
                      data={student}
                      key={index}
                      index={index}
                      getStudentsData={this.getStudentsData}
                    />
                  ))}
                </TableBody>

                <CustomTableFooter
                  count={filtered.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={this.handlePage}
                  onChangeRowsPerPage={this.handleRowsPerPage}
                />
              </Table>
            </TableContainer>
          ) : this.state.isEmpty ? (
            <CustomEmptyMessage />
          ) : (
            <CustomSiteLoader />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ViewStudent)));
